import { render } from "./SliderTeam.vue?vue&type=template&id=642550ae&scoped=true"
import script from "./SliderTeam.vue?vue&type=script&lang=js"
export * from "./SliderTeam.vue?vue&type=script&lang=js"

import "./SliderTeam.vue?vue&type=style&index=0&id=642550ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-642550ae"]])

export default __exports__